module.exports = __webpack_public_path__ + "static/media/block-user.8e0d8437.svg";